// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: every user-visible string of Bump, word for word bump-plan.md section 5 (bump_strings_table.md is the
// repo copy, checked by BumpStrings.test.ts). English only, like the calendar's. Exclude from upstream sync.

export const BumpStrings = {
	bump: 'Bump',
	bumped: 'Bumped',
	bumpedBy: 'Bumped by {name}',
	someone: 'Someone',
	rateLimited: 'You can bump this channel again in a minute.',
	tooManyTargets: "More than 25 other people can see this channel, so it can't be bumped.",
	noTargets: 'No one else can see this channel.',
	noMessages: "There's nothing to bump yet.",
	notAvailable: "Bump isn't available here.",
	failed: "The bump didn't go through. Try again.",
} as const;

export function bumpedByText(name: string): string {
	return BumpStrings.bumpedBy.replace('{name}', name);
}
